// extracted by mini-css-extract-plugin
module.exports = {"Navigator":"Navigator-module__Navigator___31V2d","navigator":"Navigator-module__Navigator___31V2d"};